import {
  DiagnosticsStackGenericResponse,
  RemoteDiagnosticsSuccessResponseData,
  RemoteDiagnosticsVddRootMetadataResponse,
  RemoteDiagnosticsVddRootStructureResponse,
} from '../remote-diagnostics.model';
import { MockedVdd } from './MockedVdd.model';
import { VddNames } from '../../../../../app/+installations/diagnostics-overlay/tabs-content/extended-parameters/diagnostics-constants';

export class InfoDtcList implements MockedVdd {
  readSingleSync(logicalLink?: string): RemoteDiagnosticsSuccessResponseData {
    return {
      RES:
        ' 62 01 03 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00',
      request_parameter_name: 'PA_DataIdent',
      service: 'DS_ReadDataByIdent',
      ecu: logicalLink ?? 'LL_0002_HMU_CAN01',
      requestDate: new Date().toISOString(),
      ecuvariant: logicalLink ?? 'LL_0002_HMU_CAN01',
      request_parameter_value: VddNames.InfoDtcList,
      securitystatus: '',
      type: 'ReadVddDataByVdd',
      structure: [
        {
          semantic: 'SERVICE-ID',
          path: 'PA_ServiID',
          unit: '',
          translationid: '',
          dopname: '',
          name: 'PA_ServiID',
          value: '98',
        },
        {
          semantic: '',
          path: 'PA_DataIdent',
          unit: '',
          translationid: '',
          dopname: '2 Byte Text Table VDD-Greenbook',
          name: 'PA_DataIdent',
          value: 'InfoDtcList',
        },
        {
          semantic: '',
          path: 'PA_DataRecor',
          translationid: '',
          dopname: '2 Byte Table VDD Greenbook',
          name: 'PA_DataRecor',
          structure: [
            {
              semantic: 'ENTRIES',
              path: 'PA_DataRecor/PA_Entri',
              unit: '',
              translationid: 'TI_Entries',
              dopname: '2 Byte Identical uint16',
              name: 'PA_Entri',
              value: '0',
            },
            {
              semantic: 'FAULTREAD',
              path: 'PA_DataRecor/PA_DTC',
              translationid: 'TI_DTC',
              dopname: 'EOPF Structure DTC Info',
              name: 'PA_DTC',
              structure: [
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo',
                  translationid: '',
                  dopname: '12 Byte Structure DTC Info',
                  name: 'STR_12ByteStrucDTCInfo',
                  structure: [
                    {
                      semantic: 'FAULTREAD',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DTC',
                      unit: '',
                      translationid: 'TI_DtcInfo',
                      dopname: '2 Byte TextTable DTCInfo',
                      name: 'PA_DTC',
                      value: 'NoInfo',
                    },
                    {
                      semantic: 'DATETIME',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime',
                      translationid: 'TI_Time',
                      dopname: '8 Byte Structure DateTime',
                      name: 'PA_DtcTime',
                      structure: [
                        {
                          semantic: 'DATE',
                          path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Date',
                          translationid: 'TI_Date',
                          dopname: '4 Byte Structure Date',
                          name: 'PA_Date',
                          structure: [
                            {
                              semantic: 'CENTURY',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Date/PA_Centu',
                              unit: '',
                              translationid: 'TI_Century',
                              dopname: '1 Byte Identical uint8 Century',
                              name: 'PA_Centu',
                              value: '0',
                            },
                            {
                              semantic: 'YEAR',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Date/PA_Year',
                              unit: 'yr',
                              translationid: 'TI_Year',
                              dopname: '1 Byte Identical uint8 Year',
                              name: 'PA_Year',
                              value: '0',
                            },
                            {
                              semantic: 'MONTH',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Date/PA_Month',
                              unit: 'm',
                              translationid: 'TI_Month',
                              dopname: '1 Byte Identical uint8 Month',
                              name: 'PA_Month',
                              value: '0',
                            },
                            {
                              semantic: 'DAY',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Date/PA_Day',
                              unit: 'd',
                              translationid: 'TI_Day',
                              dopname: '1 Byte Identical uint8 Day',
                              name: 'PA_Day',
                              value: '0',
                            },
                          ],
                        },
                        {
                          semantic: 'TIME',
                          path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Time',
                          translationid: 'TI_Time',
                          dopname: '4 Byte Structure Time',
                          name: 'PA_Time',
                          structure: [
                            {
                              semantic: 'WEEKDAY',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Time/PA_Weekd',
                              unit: '',
                              translationid: 'TI_Weekday',
                              dopname: '1 Byte TextTable WeekDay',
                              name: 'PA_Weekd',
                              value: 'Monday',
                            },
                            {
                              semantic: 'HOUR',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Time/PA_Hour',
                              unit: 'h',
                              translationid: 'TI_Hour',
                              dopname: '1 Byte Identical uint8 Hour',
                              name: 'PA_Hour',
                              value: '0',
                            },
                            {
                              semantic: 'MINUTE',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Time/PA_Minut',
                              unit: 'min',
                              translationid: 'TI_Minute',
                              dopname: '1 Byte Identical uint8 Minute',
                              name: 'PA_Minut',
                              value: '0',
                            },
                            {
                              semantic: 'SECOND',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Time/PA_Secon',
                              unit: 's',
                              translationid: 'TI_Second',
                              dopname: '1 Byte Identical uint8 Second',
                              name: 'PA_Secon',
                              value: '0',
                            },
                          ],
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_BusAddre',
                      unit: '',
                      translationid: 'TI_BusAddress',
                      dopname: '1 Byte Identical uint8 Hex',
                      name: 'PA_BusAddre',
                      value: '0',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_BusType',
                      unit: '',
                      translationid: 'TI_BusType',
                      dopname: '1 Byte TextTable BusType',
                      name: 'PA_BusType',
                      value: 'OwnBus',
                    },
                  ],
                },
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo',
                  translationid: '',
                  dopname: '12 Byte Structure DTC Info',
                  name: 'STR_12ByteStrucDTCInfo',
                  structure: [
                    {
                      semantic: 'FAULTREAD',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DTC',
                      unit: '',
                      translationid: 'TI_DtcInfo',
                      dopname: '2 Byte TextTable DTCInfo',
                      name: 'PA_DTC',
                      value: 'NoInfo',
                    },
                    {
                      semantic: 'DATETIME',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime',
                      translationid: 'TI_Time',
                      dopname: '8 Byte Structure DateTime',
                      name: 'PA_DtcTime',
                      structure: [
                        {
                          semantic: 'DATE',
                          path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Date',
                          translationid: 'TI_Date',
                          dopname: '4 Byte Structure Date',
                          name: 'PA_Date',
                          structure: [
                            {
                              semantic: 'CENTURY',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Date/PA_Centu',
                              unit: '',
                              translationid: 'TI_Century',
                              dopname: '1 Byte Identical uint8 Century',
                              name: 'PA_Centu',
                              value: '0',
                            },
                            {
                              semantic: 'YEAR',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Date/PA_Year',
                              unit: 'yr',
                              translationid: 'TI_Year',
                              dopname: '1 Byte Identical uint8 Year',
                              name: 'PA_Year',
                              value: '0',
                            },
                            {
                              semantic: 'MONTH',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Date/PA_Month',
                              unit: 'm',
                              translationid: 'TI_Month',
                              dopname: '1 Byte Identical uint8 Month',
                              name: 'PA_Month',
                              value: '0',
                            },
                            {
                              semantic: 'DAY',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Date/PA_Day',
                              unit: 'd',
                              translationid: 'TI_Day',
                              dopname: '1 Byte Identical uint8 Day',
                              name: 'PA_Day',
                              value: '0',
                            },
                          ],
                        },
                        {
                          semantic: 'TIME',
                          path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Time',
                          translationid: 'TI_Time',
                          dopname: '4 Byte Structure Time',
                          name: 'PA_Time',
                          structure: [
                            {
                              semantic: 'WEEKDAY',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Time/PA_Weekd',
                              unit: '',
                              translationid: 'TI_Weekday',
                              dopname: '1 Byte TextTable WeekDay',
                              name: 'PA_Weekd',
                              value: 'Monday',
                            },
                            {
                              semantic: 'HOUR',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Time/PA_Hour',
                              unit: 'h',
                              translationid: 'TI_Hour',
                              dopname: '1 Byte Identical uint8 Hour',
                              name: 'PA_Hour',
                              value: '0',
                            },
                            {
                              semantic: 'MINUTE',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Time/PA_Minut',
                              unit: 'min',
                              translationid: 'TI_Minute',
                              dopname: '1 Byte Identical uint8 Minute',
                              name: 'PA_Minut',
                              value: '0',
                            },
                            {
                              semantic: 'SECOND',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Time/PA_Secon',
                              unit: 's',
                              translationid: 'TI_Second',
                              dopname: '1 Byte Identical uint8 Second',
                              name: 'PA_Secon',
                              value: '0',
                            },
                          ],
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_BusAddre',
                      unit: '',
                      translationid: 'TI_BusAddress',
                      dopname: '1 Byte Identical uint8 Hex',
                      name: 'PA_BusAddre',
                      value: '0',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_BusType',
                      unit: '',
                      translationid: 'TI_BusType',
                      dopname: '1 Byte TextTable BusType',
                      name: 'PA_BusType',
                      value: 'OwnBus',
                    },
                  ],
                },
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo',
                  translationid: '',
                  dopname: '12 Byte Structure DTC Info',
                  name: 'STR_12ByteStrucDTCInfo',
                  structure: [
                    {
                      semantic: 'FAULTREAD',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DTC',
                      unit: '',
                      translationid: 'TI_DtcInfo',
                      dopname: '2 Byte TextTable DTCInfo',
                      name: 'PA_DTC',
                      value: 'NoInfo',
                    },
                    {
                      semantic: 'DATETIME',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime',
                      translationid: 'TI_Time',
                      dopname: '8 Byte Structure DateTime',
                      name: 'PA_DtcTime',
                      structure: [
                        {
                          semantic: 'DATE',
                          path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Date',
                          translationid: 'TI_Date',
                          dopname: '4 Byte Structure Date',
                          name: 'PA_Date',
                          structure: [
                            {
                              semantic: 'CENTURY',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Date/PA_Centu',
                              unit: '',
                              translationid: 'TI_Century',
                              dopname: '1 Byte Identical uint8 Century',
                              name: 'PA_Centu',
                              value: '0',
                            },
                            {
                              semantic: 'YEAR',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Date/PA_Year',
                              unit: 'yr',
                              translationid: 'TI_Year',
                              dopname: '1 Byte Identical uint8 Year',
                              name: 'PA_Year',
                              value: '0',
                            },
                            {
                              semantic: 'MONTH',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Date/PA_Month',
                              unit: 'm',
                              translationid: 'TI_Month',
                              dopname: '1 Byte Identical uint8 Month',
                              name: 'PA_Month',
                              value: '0',
                            },
                            {
                              semantic: 'DAY',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Date/PA_Day',
                              unit: 'd',
                              translationid: 'TI_Day',
                              dopname: '1 Byte Identical uint8 Day',
                              name: 'PA_Day',
                              value: '0',
                            },
                          ],
                        },
                        {
                          semantic: 'TIME',
                          path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Time',
                          translationid: 'TI_Time',
                          dopname: '4 Byte Structure Time',
                          name: 'PA_Time',
                          structure: [
                            {
                              semantic: 'WEEKDAY',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Time/PA_Weekd',
                              unit: '',
                              translationid: 'TI_Weekday',
                              dopname: '1 Byte TextTable WeekDay',
                              name: 'PA_Weekd',
                              value: 'Monday',
                            },
                            {
                              semantic: 'HOUR',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Time/PA_Hour',
                              unit: 'h',
                              translationid: 'TI_Hour',
                              dopname: '1 Byte Identical uint8 Hour',
                              name: 'PA_Hour',
                              value: '0',
                            },
                            {
                              semantic: 'MINUTE',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Time/PA_Minut',
                              unit: 'min',
                              translationid: 'TI_Minute',
                              dopname: '1 Byte Identical uint8 Minute',
                              name: 'PA_Minut',
                              value: '0',
                            },
                            {
                              semantic: 'SECOND',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Time/PA_Secon',
                              unit: 's',
                              translationid: 'TI_Second',
                              dopname: '1 Byte Identical uint8 Second',
                              name: 'PA_Secon',
                              value: '0',
                            },
                          ],
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_BusAddre',
                      unit: '',
                      translationid: 'TI_BusAddress',
                      dopname: '1 Byte Identical uint8 Hex',
                      name: 'PA_BusAddre',
                      value: '0',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_BusType',
                      unit: '',
                      translationid: 'TI_BusType',
                      dopname: '1 Byte TextTable BusType',
                      name: 'PA_BusType',
                      value: 'OwnBus',
                    },
                  ],
                },
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo',
                  translationid: '',
                  dopname: '12 Byte Structure DTC Info',
                  name: 'STR_12ByteStrucDTCInfo',
                  structure: [
                    {
                      semantic: 'FAULTREAD',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DTC',
                      unit: '',
                      translationid: 'TI_DtcInfo',
                      dopname: '2 Byte TextTable DTCInfo',
                      name: 'PA_DTC',
                      value: 'NoInfo',
                    },
                    {
                      semantic: 'DATETIME',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime',
                      translationid: 'TI_Time',
                      dopname: '8 Byte Structure DateTime',
                      name: 'PA_DtcTime',
                      structure: [
                        {
                          semantic: 'DATE',
                          path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Date',
                          translationid: 'TI_Date',
                          dopname: '4 Byte Structure Date',
                          name: 'PA_Date',
                          structure: [
                            {
                              semantic: 'CENTURY',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Date/PA_Centu',
                              unit: '',
                              translationid: 'TI_Century',
                              dopname: '1 Byte Identical uint8 Century',
                              name: 'PA_Centu',
                              value: '0',
                            },
                            {
                              semantic: 'YEAR',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Date/PA_Year',
                              unit: 'yr',
                              translationid: 'TI_Year',
                              dopname: '1 Byte Identical uint8 Year',
                              name: 'PA_Year',
                              value: '0',
                            },
                            {
                              semantic: 'MONTH',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Date/PA_Month',
                              unit: 'm',
                              translationid: 'TI_Month',
                              dopname: '1 Byte Identical uint8 Month',
                              name: 'PA_Month',
                              value: '0',
                            },
                            {
                              semantic: 'DAY',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Date/PA_Day',
                              unit: 'd',
                              translationid: 'TI_Day',
                              dopname: '1 Byte Identical uint8 Day',
                              name: 'PA_Day',
                              value: '0',
                            },
                          ],
                        },
                        {
                          semantic: 'TIME',
                          path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Time',
                          translationid: 'TI_Time',
                          dopname: '4 Byte Structure Time',
                          name: 'PA_Time',
                          structure: [
                            {
                              semantic: 'WEEKDAY',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Time/PA_Weekd',
                              unit: '',
                              translationid: 'TI_Weekday',
                              dopname: '1 Byte TextTable WeekDay',
                              name: 'PA_Weekd',
                              value: 'Monday',
                            },
                            {
                              semantic: 'HOUR',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Time/PA_Hour',
                              unit: 'h',
                              translationid: 'TI_Hour',
                              dopname: '1 Byte Identical uint8 Hour',
                              name: 'PA_Hour',
                              value: '0',
                            },
                            {
                              semantic: 'MINUTE',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Time/PA_Minut',
                              unit: 'min',
                              translationid: 'TI_Minute',
                              dopname: '1 Byte Identical uint8 Minute',
                              name: 'PA_Minut',
                              value: '0',
                            },
                            {
                              semantic: 'SECOND',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Time/PA_Secon',
                              unit: 's',
                              translationid: 'TI_Second',
                              dopname: '1 Byte Identical uint8 Second',
                              name: 'PA_Secon',
                              value: '0',
                            },
                          ],
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_BusAddre',
                      unit: '',
                      translationid: 'TI_BusAddress',
                      dopname: '1 Byte Identical uint8 Hex',
                      name: 'PA_BusAddre',
                      value: '0',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_BusType',
                      unit: '',
                      translationid: 'TI_BusType',
                      dopname: '1 Byte TextTable BusType',
                      name: 'PA_BusType',
                      value: 'OwnBus',
                    },
                  ],
                },
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo',
                  translationid: '',
                  dopname: '12 Byte Structure DTC Info',
                  name: 'STR_12ByteStrucDTCInfo',
                  structure: [
                    {
                      semantic: 'FAULTREAD',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DTC',
                      unit: '',
                      translationid: 'TI_DtcInfo',
                      dopname: '2 Byte TextTable DTCInfo',
                      name: 'PA_DTC',
                      value: 'NoInfo',
                    },
                    {
                      semantic: 'DATETIME',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime',
                      translationid: 'TI_Time',
                      dopname: '8 Byte Structure DateTime',
                      name: 'PA_DtcTime',
                      structure: [
                        {
                          semantic: 'DATE',
                          path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Date',
                          translationid: 'TI_Date',
                          dopname: '4 Byte Structure Date',
                          name: 'PA_Date',
                          structure: [
                            {
                              semantic: 'CENTURY',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Date/PA_Centu',
                              unit: '',
                              translationid: 'TI_Century',
                              dopname: '1 Byte Identical uint8 Century',
                              name: 'PA_Centu',
                              value: '0',
                            },
                            {
                              semantic: 'YEAR',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Date/PA_Year',
                              unit: 'yr',
                              translationid: 'TI_Year',
                              dopname: '1 Byte Identical uint8 Year',
                              name: 'PA_Year',
                              value: '0',
                            },
                            {
                              semantic: 'MONTH',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Date/PA_Month',
                              unit: 'm',
                              translationid: 'TI_Month',
                              dopname: '1 Byte Identical uint8 Month',
                              name: 'PA_Month',
                              value: '0',
                            },
                            {
                              semantic: 'DAY',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Date/PA_Day',
                              unit: 'd',
                              translationid: 'TI_Day',
                              dopname: '1 Byte Identical uint8 Day',
                              name: 'PA_Day',
                              value: '0',
                            },
                          ],
                        },
                        {
                          semantic: 'TIME',
                          path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Time',
                          translationid: 'TI_Time',
                          dopname: '4 Byte Structure Time',
                          name: 'PA_Time',
                          structure: [
                            {
                              semantic: 'WEEKDAY',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Time/PA_Weekd',
                              unit: '',
                              translationid: 'TI_Weekday',
                              dopname: '1 Byte TextTable WeekDay',
                              name: 'PA_Weekd',
                              value: 'Monday',
                            },
                            {
                              semantic: 'HOUR',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Time/PA_Hour',
                              unit: 'h',
                              translationid: 'TI_Hour',
                              dopname: '1 Byte Identical uint8 Hour',
                              name: 'PA_Hour',
                              value: '0',
                            },
                            {
                              semantic: 'MINUTE',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Time/PA_Minut',
                              unit: 'min',
                              translationid: 'TI_Minute',
                              dopname: '1 Byte Identical uint8 Minute',
                              name: 'PA_Minut',
                              value: '0',
                            },
                            {
                              semantic: 'SECOND',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Time/PA_Secon',
                              unit: 's',
                              translationid: 'TI_Second',
                              dopname: '1 Byte Identical uint8 Second',
                              name: 'PA_Secon',
                              value: '0',
                            },
                          ],
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_BusAddre',
                      unit: '',
                      translationid: 'TI_BusAddress',
                      dopname: '1 Byte Identical uint8 Hex',
                      name: 'PA_BusAddre',
                      value: '0',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_BusType',
                      unit: '',
                      translationid: 'TI_BusType',
                      dopname: '1 Byte TextTable BusType',
                      name: 'PA_BusType',
                      value: 'OwnBus',
                    },
                  ],
                },
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo',
                  translationid: '',
                  dopname: '12 Byte Structure DTC Info',
                  name: 'STR_12ByteStrucDTCInfo',
                  structure: [
                    {
                      semantic: 'FAULTREAD',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DTC',
                      unit: '',
                      translationid: 'TI_DtcInfo',
                      dopname: '2 Byte TextTable DTCInfo',
                      name: 'PA_DTC',
                      value: 'NoInfo',
                    },
                    {
                      semantic: 'DATETIME',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime',
                      translationid: 'TI_Time',
                      dopname: '8 Byte Structure DateTime',
                      name: 'PA_DtcTime',
                      structure: [
                        {
                          semantic: 'DATE',
                          path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Date',
                          translationid: 'TI_Date',
                          dopname: '4 Byte Structure Date',
                          name: 'PA_Date',
                          structure: [
                            {
                              semantic: 'CENTURY',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Date/PA_Centu',
                              unit: '',
                              translationid: 'TI_Century',
                              dopname: '1 Byte Identical uint8 Century',
                              name: 'PA_Centu',
                              value: '0',
                            },
                            {
                              semantic: 'YEAR',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Date/PA_Year',
                              unit: 'yr',
                              translationid: 'TI_Year',
                              dopname: '1 Byte Identical uint8 Year',
                              name: 'PA_Year',
                              value: '0',
                            },
                            {
                              semantic: 'MONTH',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Date/PA_Month',
                              unit: 'm',
                              translationid: 'TI_Month',
                              dopname: '1 Byte Identical uint8 Month',
                              name: 'PA_Month',
                              value: '0',
                            },
                            {
                              semantic: 'DAY',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Date/PA_Day',
                              unit: 'd',
                              translationid: 'TI_Day',
                              dopname: '1 Byte Identical uint8 Day',
                              name: 'PA_Day',
                              value: '0',
                            },
                          ],
                        },
                        {
                          semantic: 'TIME',
                          path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Time',
                          translationid: 'TI_Time',
                          dopname: '4 Byte Structure Time',
                          name: 'PA_Time',
                          structure: [
                            {
                              semantic: 'WEEKDAY',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Time/PA_Weekd',
                              unit: '',
                              translationid: 'TI_Weekday',
                              dopname: '1 Byte TextTable WeekDay',
                              name: 'PA_Weekd',
                              value: 'Monday',
                            },
                            {
                              semantic: 'HOUR',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Time/PA_Hour',
                              unit: 'h',
                              translationid: 'TI_Hour',
                              dopname: '1 Byte Identical uint8 Hour',
                              name: 'PA_Hour',
                              value: '0',
                            },
                            {
                              semantic: 'MINUTE',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Time/PA_Minut',
                              unit: 'min',
                              translationid: 'TI_Minute',
                              dopname: '1 Byte Identical uint8 Minute',
                              name: 'PA_Minut',
                              value: '0',
                            },
                            {
                              semantic: 'SECOND',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Time/PA_Secon',
                              unit: 's',
                              translationid: 'TI_Second',
                              dopname: '1 Byte Identical uint8 Second',
                              name: 'PA_Secon',
                              value: '0',
                            },
                          ],
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_BusAddre',
                      unit: '',
                      translationid: 'TI_BusAddress',
                      dopname: '1 Byte Identical uint8 Hex',
                      name: 'PA_BusAddre',
                      value: '0',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_BusType',
                      unit: '',
                      translationid: 'TI_BusType',
                      dopname: '1 Byte TextTable BusType',
                      name: 'PA_BusType',
                      value: 'OwnBus',
                    },
                  ],
                },
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo',
                  translationid: '',
                  dopname: '12 Byte Structure DTC Info',
                  name: 'STR_12ByteStrucDTCInfo',
                  structure: [
                    {
                      semantic: 'FAULTREAD',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DTC',
                      unit: '',
                      translationid: 'TI_DtcInfo',
                      dopname: '2 Byte TextTable DTCInfo',
                      name: 'PA_DTC',
                      value: 'NoInfo',
                    },
                    {
                      semantic: 'DATETIME',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime',
                      translationid: 'TI_Time',
                      dopname: '8 Byte Structure DateTime',
                      name: 'PA_DtcTime',
                      structure: [
                        {
                          semantic: 'DATE',
                          path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Date',
                          translationid: 'TI_Date',
                          dopname: '4 Byte Structure Date',
                          name: 'PA_Date',
                          structure: [
                            {
                              semantic: 'CENTURY',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Date/PA_Centu',
                              unit: '',
                              translationid: 'TI_Century',
                              dopname: '1 Byte Identical uint8 Century',
                              name: 'PA_Centu',
                              value: '0',
                            },
                            {
                              semantic: 'YEAR',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Date/PA_Year',
                              unit: 'yr',
                              translationid: 'TI_Year',
                              dopname: '1 Byte Identical uint8 Year',
                              name: 'PA_Year',
                              value: '0',
                            },
                            {
                              semantic: 'MONTH',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Date/PA_Month',
                              unit: 'm',
                              translationid: 'TI_Month',
                              dopname: '1 Byte Identical uint8 Month',
                              name: 'PA_Month',
                              value: '0',
                            },
                            {
                              semantic: 'DAY',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Date/PA_Day',
                              unit: 'd',
                              translationid: 'TI_Day',
                              dopname: '1 Byte Identical uint8 Day',
                              name: 'PA_Day',
                              value: '0',
                            },
                          ],
                        },
                        {
                          semantic: 'TIME',
                          path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Time',
                          translationid: 'TI_Time',
                          dopname: '4 Byte Structure Time',
                          name: 'PA_Time',
                          structure: [
                            {
                              semantic: 'WEEKDAY',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Time/PA_Weekd',
                              unit: '',
                              translationid: 'TI_Weekday',
                              dopname: '1 Byte TextTable WeekDay',
                              name: 'PA_Weekd',
                              value: 'Monday',
                            },
                            {
                              semantic: 'HOUR',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Time/PA_Hour',
                              unit: 'h',
                              translationid: 'TI_Hour',
                              dopname: '1 Byte Identical uint8 Hour',
                              name: 'PA_Hour',
                              value: '0',
                            },
                            {
                              semantic: 'MINUTE',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Time/PA_Minut',
                              unit: 'min',
                              translationid: 'TI_Minute',
                              dopname: '1 Byte Identical uint8 Minute',
                              name: 'PA_Minut',
                              value: '0',
                            },
                            {
                              semantic: 'SECOND',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Time/PA_Secon',
                              unit: 's',
                              translationid: 'TI_Second',
                              dopname: '1 Byte Identical uint8 Second',
                              name: 'PA_Secon',
                              value: '0',
                            },
                          ],
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_BusAddre',
                      unit: '',
                      translationid: 'TI_BusAddress',
                      dopname: '1 Byte Identical uint8 Hex',
                      name: 'PA_BusAddre',
                      value: '0',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_BusType',
                      unit: '',
                      translationid: 'TI_BusType',
                      dopname: '1 Byte TextTable BusType',
                      name: 'PA_BusType',
                      value: 'OwnBus',
                    },
                  ],
                },
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo',
                  translationid: '',
                  dopname: '12 Byte Structure DTC Info',
                  name: 'STR_12ByteStrucDTCInfo',
                  structure: [
                    {
                      semantic: 'FAULTREAD',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DTC',
                      unit: '',
                      translationid: 'TI_DtcInfo',
                      dopname: '2 Byte TextTable DTCInfo',
                      name: 'PA_DTC',
                      value: 'NoInfo',
                    },
                    {
                      semantic: 'DATETIME',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime',
                      translationid: 'TI_Time',
                      dopname: '8 Byte Structure DateTime',
                      name: 'PA_DtcTime',
                      structure: [
                        {
                          semantic: 'DATE',
                          path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Date',
                          translationid: 'TI_Date',
                          dopname: '4 Byte Structure Date',
                          name: 'PA_Date',
                          structure: [
                            {
                              semantic: 'CENTURY',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Date/PA_Centu',
                              unit: '',
                              translationid: 'TI_Century',
                              dopname: '1 Byte Identical uint8 Century',
                              name: 'PA_Centu',
                              value: '0',
                            },
                            {
                              semantic: 'YEAR',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Date/PA_Year',
                              unit: 'yr',
                              translationid: 'TI_Year',
                              dopname: '1 Byte Identical uint8 Year',
                              name: 'PA_Year',
                              value: '0',
                            },
                            {
                              semantic: 'MONTH',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Date/PA_Month',
                              unit: 'm',
                              translationid: 'TI_Month',
                              dopname: '1 Byte Identical uint8 Month',
                              name: 'PA_Month',
                              value: '0',
                            },
                            {
                              semantic: 'DAY',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Date/PA_Day',
                              unit: 'd',
                              translationid: 'TI_Day',
                              dopname: '1 Byte Identical uint8 Day',
                              name: 'PA_Day',
                              value: '0',
                            },
                          ],
                        },
                        {
                          semantic: 'TIME',
                          path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Time',
                          translationid: 'TI_Time',
                          dopname: '4 Byte Structure Time',
                          name: 'PA_Time',
                          structure: [
                            {
                              semantic: 'WEEKDAY',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Time/PA_Weekd',
                              unit: '',
                              translationid: 'TI_Weekday',
                              dopname: '1 Byte TextTable WeekDay',
                              name: 'PA_Weekd',
                              value: 'Monday',
                            },
                            {
                              semantic: 'HOUR',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Time/PA_Hour',
                              unit: 'h',
                              translationid: 'TI_Hour',
                              dopname: '1 Byte Identical uint8 Hour',
                              name: 'PA_Hour',
                              value: '0',
                            },
                            {
                              semantic: 'MINUTE',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Time/PA_Minut',
                              unit: 'min',
                              translationid: 'TI_Minute',
                              dopname: '1 Byte Identical uint8 Minute',
                              name: 'PA_Minut',
                              value: '0',
                            },
                            {
                              semantic: 'SECOND',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Time/PA_Secon',
                              unit: 's',
                              translationid: 'TI_Second',
                              dopname: '1 Byte Identical uint8 Second',
                              name: 'PA_Secon',
                              value: '0',
                            },
                          ],
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_BusAddre',
                      unit: '',
                      translationid: 'TI_BusAddress',
                      dopname: '1 Byte Identical uint8 Hex',
                      name: 'PA_BusAddre',
                      value: '0',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_BusType',
                      unit: '',
                      translationid: 'TI_BusType',
                      dopname: '1 Byte TextTable BusType',
                      name: 'PA_BusType',
                      value: 'OwnBus',
                    },
                  ],
                },
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo',
                  translationid: '',
                  dopname: '12 Byte Structure DTC Info',
                  name: 'STR_12ByteStrucDTCInfo',
                  structure: [
                    {
                      semantic: 'FAULTREAD',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DTC',
                      unit: '',
                      translationid: 'TI_DtcInfo',
                      dopname: '2 Byte TextTable DTCInfo',
                      name: 'PA_DTC',
                      value: 'NoInfo',
                    },
                    {
                      semantic: 'DATETIME',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime',
                      translationid: 'TI_Time',
                      dopname: '8 Byte Structure DateTime',
                      name: 'PA_DtcTime',
                      structure: [
                        {
                          semantic: 'DATE',
                          path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Date',
                          translationid: 'TI_Date',
                          dopname: '4 Byte Structure Date',
                          name: 'PA_Date',
                          structure: [
                            {
                              semantic: 'CENTURY',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Date/PA_Centu',
                              unit: '',
                              translationid: 'TI_Century',
                              dopname: '1 Byte Identical uint8 Century',
                              name: 'PA_Centu',
                              value: '0',
                            },
                            {
                              semantic: 'YEAR',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Date/PA_Year',
                              unit: 'yr',
                              translationid: 'TI_Year',
                              dopname: '1 Byte Identical uint8 Year',
                              name: 'PA_Year',
                              value: '0',
                            },
                            {
                              semantic: 'MONTH',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Date/PA_Month',
                              unit: 'm',
                              translationid: 'TI_Month',
                              dopname: '1 Byte Identical uint8 Month',
                              name: 'PA_Month',
                              value: '0',
                            },
                            {
                              semantic: 'DAY',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Date/PA_Day',
                              unit: 'd',
                              translationid: 'TI_Day',
                              dopname: '1 Byte Identical uint8 Day',
                              name: 'PA_Day',
                              value: '0',
                            },
                          ],
                        },
                        {
                          semantic: 'TIME',
                          path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Time',
                          translationid: 'TI_Time',
                          dopname: '4 Byte Structure Time',
                          name: 'PA_Time',
                          structure: [
                            {
                              semantic: 'WEEKDAY',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Time/PA_Weekd',
                              unit: '',
                              translationid: 'TI_Weekday',
                              dopname: '1 Byte TextTable WeekDay',
                              name: 'PA_Weekd',
                              value: 'Monday',
                            },
                            {
                              semantic: 'HOUR',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Time/PA_Hour',
                              unit: 'h',
                              translationid: 'TI_Hour',
                              dopname: '1 Byte Identical uint8 Hour',
                              name: 'PA_Hour',
                              value: '0',
                            },
                            {
                              semantic: 'MINUTE',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Time/PA_Minut',
                              unit: 'min',
                              translationid: 'TI_Minute',
                              dopname: '1 Byte Identical uint8 Minute',
                              name: 'PA_Minut',
                              value: '0',
                            },
                            {
                              semantic: 'SECOND',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Time/PA_Secon',
                              unit: 's',
                              translationid: 'TI_Second',
                              dopname: '1 Byte Identical uint8 Second',
                              name: 'PA_Secon',
                              value: '0',
                            },
                          ],
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_BusAddre',
                      unit: '',
                      translationid: 'TI_BusAddress',
                      dopname: '1 Byte Identical uint8 Hex',
                      name: 'PA_BusAddre',
                      value: '0',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_BusType',
                      unit: '',
                      translationid: 'TI_BusType',
                      dopname: '1 Byte TextTable BusType',
                      name: 'PA_BusType',
                      value: 'OwnBus',
                    },
                  ],
                },
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo',
                  translationid: '',
                  dopname: '12 Byte Structure DTC Info',
                  name: 'STR_12ByteStrucDTCInfo',
                  structure: [
                    {
                      semantic: 'FAULTREAD',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DTC',
                      unit: '',
                      translationid: 'TI_DtcInfo',
                      dopname: '2 Byte TextTable DTCInfo',
                      name: 'PA_DTC',
                      value: 'NoInfo',
                    },
                    {
                      semantic: 'DATETIME',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime',
                      translationid: 'TI_Time',
                      dopname: '8 Byte Structure DateTime',
                      name: 'PA_DtcTime',
                      structure: [
                        {
                          semantic: 'DATE',
                          path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Date',
                          translationid: 'TI_Date',
                          dopname: '4 Byte Structure Date',
                          name: 'PA_Date',
                          structure: [
                            {
                              semantic: 'CENTURY',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Date/PA_Centu',
                              unit: '',
                              translationid: 'TI_Century',
                              dopname: '1 Byte Identical uint8 Century',
                              name: 'PA_Centu',
                              value: '0',
                            },
                            {
                              semantic: 'YEAR',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Date/PA_Year',
                              unit: 'yr',
                              translationid: 'TI_Year',
                              dopname: '1 Byte Identical uint8 Year',
                              name: 'PA_Year',
                              value: '0',
                            },
                            {
                              semantic: 'MONTH',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Date/PA_Month',
                              unit: 'm',
                              translationid: 'TI_Month',
                              dopname: '1 Byte Identical uint8 Month',
                              name: 'PA_Month',
                              value: '0',
                            },
                            {
                              semantic: 'DAY',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Date/PA_Day',
                              unit: 'd',
                              translationid: 'TI_Day',
                              dopname: '1 Byte Identical uint8 Day',
                              name: 'PA_Day',
                              value: '0',
                            },
                          ],
                        },
                        {
                          semantic: 'TIME',
                          path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Time',
                          translationid: 'TI_Time',
                          dopname: '4 Byte Structure Time',
                          name: 'PA_Time',
                          structure: [
                            {
                              semantic: 'WEEKDAY',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Time/PA_Weekd',
                              unit: '',
                              translationid: 'TI_Weekday',
                              dopname: '1 Byte TextTable WeekDay',
                              name: 'PA_Weekd',
                              value: 'Monday',
                            },
                            {
                              semantic: 'HOUR',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Time/PA_Hour',
                              unit: 'h',
                              translationid: 'TI_Hour',
                              dopname: '1 Byte Identical uint8 Hour',
                              name: 'PA_Hour',
                              value: '0',
                            },
                            {
                              semantic: 'MINUTE',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Time/PA_Minut',
                              unit: 'min',
                              translationid: 'TI_Minute',
                              dopname: '1 Byte Identical uint8 Minute',
                              name: 'PA_Minut',
                              value: '0',
                            },
                            {
                              semantic: 'SECOND',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Time/PA_Secon',
                              unit: 's',
                              translationid: 'TI_Second',
                              dopname: '1 Byte Identical uint8 Second',
                              name: 'PA_Secon',
                              value: '0',
                            },
                          ],
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_BusAddre',
                      unit: '',
                      translationid: 'TI_BusAddress',
                      dopname: '1 Byte Identical uint8 Hex',
                      name: 'PA_BusAddre',
                      value: '0',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCInfo/PA_BusType',
                      unit: '',
                      translationid: 'TI_BusType',
                      dopname: '1 Byte TextTable BusType',
                      name: 'PA_BusType',
                      value: 'OwnBus',
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          semantic: '',
          path: 'PA_RecorDataIdentCheck',
          unit: '',
          translationid: '',
          dopname: '',
          name: 'PA_RecorDataIdentCheck',
          value: '',
        },
      ],
      REQ: ' 22 01 03',
    };
  }

  metadata(): RemoteDiagnosticsVddRootMetadataResponse {
    return {
      request_parameter_name: 'PA_Param',
      service: 'DS_VDDMetaData',
      ecu: 'LL_0002_HMU_CAN01',
      request_parameter_value: VddNames.InfoDtcList,
      type: 'MetaDataByVddAndBaseVariant',
      structure: [
        {
          semantic: '',
          longname: 'Param',
          byteposition: '0',
          dopname: '2 Byte Text Table VDD-Greenbook',
          precision: '',
          byteLength: '16',
          type: 'eKEY',
          shortname: 'PA_Param',
          constraints: '',
          path: 'PA_Param',
          unit: '',
          translationid: '',
          bitposition: '0',
          name: 'PA_Param',
          interval: '259',
          value: 'InfoDtcList',
        },
        {
          semantic: '',
          longname: 'Value',
          byteposition: '2',
          dopname: '2 Byte Table VDD MetaData',
          precision: '',
          byteLength: '-1',
          type: 'eTABLE',
          shortname: 'PA_Value',
          constraints: '',
          structure: [
            {
              semantic: 'MODIFIABLE',
              longname: 'Modifiable',
              byteposition: '0',
              dopname: '1 Byte TextTable FalseTrue',
              precision: '',
              byteLength: '8',
              type: 'eTEXTTABLE',
              shortname: 'PA_Modif',
              constraints: '',
              structure: [
                { TI_texttableentry: 'TI_False', interval: '0', texttableentry: 'False' },
                { TI_texttableentry: 'TI_True', interval: '1', texttableentry: 'True' },
              ],
              path: 'PA_Value/PA_Modif',
              unit: '',
              translationid: 'TI_Modifiable',
              bitposition: '0',
              name: 'PA_Modif',
              value: 'False',
            },
          ],
          path: 'PA_Value',
          unit: '',
          translationid: '',
          bitposition: '0',
          name: 'PA_Value',
          value: '',
        },
      ],
    };
  }

  structure(): DiagnosticsStackGenericResponse<RemoteDiagnosticsVddRootStructureResponse[]> {
    return {
      type: 'VddStructureByVddAndBaseVariant',
      structure: [
        {
          request_parameter_name: 'PA_Param',
          service: 'DS_VDDPAStruc',
          ecu: 'LL_0002_HMU_CAN01',
          request_parameter_value: VddNames.InfoDtcList,
          type: 'RequestStructureByParameterNameAndValue',
          structure: [
            {
              semantic: '',
              longname: 'Param',
              byteposition: '0',
              dopname: '2 Byte Text Table VDD-Greenbook',
              precision: '',
              byteLength: '16',
              type: 'eKEY',
              shortname: 'PA_Param',
              constraints: '',
              path: 'PA_Param',
              unit: '',
              translationid: '',
              bitposition: '0',
              name: 'PA_Param',
              interval: '259',
              value: 'InfoDtcList',
            },
            {
              semantic: '',
              longname: 'Structure',
              byteposition: '2',
              dopname: '2 Byte Table VDD Greenbook',
              precision: '',
              byteLength: '-1',
              type: 'eTABLE',
              shortname: 'PA_Struc',
              constraints: '',
              structure: [
                {
                  semantic: 'ENTRIES',
                  longname: 'Entries',
                  byteposition: '0',
                  dopname: '2 Byte Identical uint16',
                  precision: '',
                  byteLength: '16',
                  type: 'eA_UINT32',
                  shortname: 'PA_Entri',
                  constraints: '[0:65535]',
                  path: 'PA_Struc/PA_Entri',
                  unit: '',
                  translationid: 'TI_Entries',
                  bitposition: '0',
                  name: 'PA_Entri',
                  value: '0',
                },
                {
                  semantic: 'FAULTREAD',
                  longname: 'DTC',
                  byteposition: '2',
                  dopname: 'EOPF Structure DTC Info',
                  precision: '',
                  byteLength: '-1',
                  type: 'eEND_OF_PDU',
                  shortname: 'PA_DTC',
                  constraints: '[1:32767]',
                  structure: [
                    {
                      semantic: '',
                      longname: '12 Byte Structure DTC Info',
                      byteposition: '-1',
                      dopname: '12 Byte Structure DTC Info',
                      precision: '',
                      byteLength: '-1',
                      type: 'eSTRUCTURE',
                      shortname: 'STR_12ByteStrucDTCInfo',
                      constraints: '',
                      structure: [
                        {
                          semantic: 'FAULTREAD',
                          longname: 'DTC',
                          byteposition: '0',
                          dopname: '2 Byte TextTable DTCInfo',
                          precision: '',
                          byteLength: '16',
                          type: 'eTEXTTABLE',
                          shortname: 'PA_DTC',
                          constraints: '',
                          structure: [
                            {
                              TI_texttableentry: 'TI_I_0',
                              interval: '0',
                              texttableentry: 'NoInfo',
                            },
                            {
                              TI_texttableentry: 'TI_I_1',
                              interval: '1',
                              texttableentry: 'EcoModeIsActive',
                            },
                            {
                              TI_texttableentry: 'TI_I_2',
                              interval: '2',
                              texttableentry: 'ChimneySweeperIsActive',
                            },
                            {
                              TI_texttableentry: 'TI_I_3',
                              interval: '3',
                              texttableentry: 'ModulationBlockingTimeIsActive',
                            },
                            {
                              TI_texttableentry: 'TI_I_4',
                              interval: '4',
                              texttableentry: 'LimpHomeModeIsActive',
                            },
                            {
                              TI_texttableentry: 'TI_I_5',
                              interval: '5',
                              texttableentry: 'UnreadyInstallationWizard',
                            },
                            {
                              TI_texttableentry: 'TI_I_6',
                              interval: '6',
                              texttableentry: 'UnreadySparePartCase',
                            },
                            {
                              TI_texttableentry: 'TI_I_7',
                              interval: '7',
                              texttableentry: 'CloudCommunicationDisrupted',
                            },
                            {
                              TI_texttableentry: 'TI_I_8',
                              interval: '8',
                              texttableentry: 'ExternalPowerOff',
                            },
                            {
                              TI_texttableentry: 'TI_I_9',
                              interval: '9',
                              texttableentry: 'FloorDryingIsActive',
                            },
                            {
                              TI_texttableentry: 'TI_I_10',
                              interval: '10',
                              texttableentry: 'DomesticHotWaterRunningTimeLimitation',
                            },
                            {
                              TI_texttableentry: 'TI_I_11',
                              interval: '11',
                              texttableentry: 'GasAirRatioSystemCalibrationActive',
                            },
                            {
                              TI_texttableentry: 'TI_I_12',
                              interval: '12',
                              texttableentry: 'SolarHeatingSupportIsActive',
                            },
                            {
                              TI_texttableentry: 'TI_I_13',
                              interval: '13',
                              texttableentry: 'IgnitionFailureOnStopping',
                            },
                            {
                              TI_texttableentry: 'TI_I_14',
                              interval: '14',
                              texttableentry: 'FlameOutDuringFuelProcessorPurge',
                            },
                            {
                              TI_texttableentry: 'TI_I_15',
                              interval: '15',
                              texttableentry: 'ProcessWaterPumpFailure',
                            },
                            {
                              TI_texttableentry: 'TI_I_16',
                              interval: '16',
                              texttableentry: 'ProcessWaterPumpInStopping',
                            },
                            {
                              TI_texttableentry: 'TI_I_17',
                              interval: '17',
                              texttableentry: 'ReformingThermocoupleTemperatureLow',
                            },
                            {
                              TI_texttableentry: 'TI_I_18',
                              interval: '18',
                              texttableentry: 'StoppingReformingThermocoupleShortCirctuit',
                            },
                            {
                              TI_texttableentry: 'TI_I_19',
                              interval: '19',
                              texttableentry: 'ShiftCatalystThermocoupleLowTemperatureInStopping',
                            },
                            {
                              TI_texttableentry: 'TI_I_20',
                              interval: '20',
                              texttableentry: 'ShiftCatalystThermocoupleShortCircuitInStopping',
                            },
                            {
                              TI_texttableentry: 'TI_I_21',
                              interval: '21',
                              texttableentry:
                                'PreferedOxidationTemperatureSensorLowTemperatureInStopping',
                            },
                            {
                              TI_texttableentry: 'TI_I_22',
                              interval: '22',
                              texttableentry:
                                'PreferedOxidationTemperatureSensorHighTemperatureInStopping',
                            },
                            {
                              TI_texttableentry: 'TI_I_23',
                              interval: '23',
                              texttableentry: 'InletWaterLowTemperature',
                            },
                            {
                              TI_texttableentry: 'TI_I_24',
                              interval: '24',
                              texttableentry: 'InletWaterHighTemperatureInStopping',
                            },
                            {
                              TI_texttableentry: 'TI_I_25',
                              interval: '25',
                              texttableentry: 'OutletWaterTemperature',
                            },
                            {
                              TI_texttableentry: 'TI_I_26',
                              interval: '26',
                              texttableentry: 'OutletWaterHighTemperatureInStopping',
                            },
                            {
                              TI_texttableentry: 'TI_I_27',
                              interval: '27',
                              texttableentry: 'CombustionAirFlowMeterBFailure',
                            },
                            {
                              TI_texttableentry: 'TI_I_28',
                              interval: '28',
                              texttableentry: 'CombustionAirLineFailure',
                            },
                            {
                              TI_texttableentry: 'TI_I_29',
                              interval: '29',
                              texttableentry: 'CombustionAirFanBFailure',
                            },
                            {
                              TI_texttableentry: 'TI_I_30',
                              interval: '30',
                              texttableentry: 'CirculationPumpFailure',
                            },
                            {
                              TI_texttableentry: 'TI_I_31',
                              interval: '31',
                              texttableentry: 'CoolingWaterCirculationPumpFailure',
                            },
                            {
                              TI_texttableentry: 'TI_I_32',
                              interval: '32',
                              texttableentry: 'FuelProcessorElectricalHeaterFailure',
                            },
                            {
                              TI_texttableentry: 'TI_I_33',
                              interval: '33',
                              texttableentry: 'FuelProcessorElectricalHeaterOffFailure',
                            },
                            {
                              TI_texttableentry: 'TI_I_34',
                              interval: '34',
                              texttableentry: 'FuelProcessorElectricalHeaterOnFailure',
                            },
                            {
                              TI_texttableentry: 'TI_I_35',
                              interval: '35',
                              texttableentry: 'DesulfurizingHeaterFailure',
                            },
                            {
                              TI_texttableentry: 'TI_I_36',
                              interval: '36',
                              texttableentry: 'DesulfurizingHeaterOffFailure',
                            },
                            {
                              TI_texttableentry: 'TI_I_37',
                              interval: '37',
                              texttableentry: 'DesulfurizingHeaterOnFailure',
                            },
                            {
                              TI_texttableentry: 'TI_I_38',
                              interval: '38',
                              texttableentry: 'SystemOutletTemperature',
                            },
                            {
                              TI_texttableentry: 'TI_I_39',
                              interval: '39',
                              texttableentry: 'SystemOutletTemperatureHigh',
                            },
                            {
                              TI_texttableentry: 'TI_I_40',
                              interval: '40',
                              texttableentry: 'SystemOutletTemperatureHighInStopping',
                            },
                            {
                              TI_texttableentry: 'TI_I_41',
                              interval: '41',
                              texttableentry: 'CoolingWaterTankThermistorHighTemperatureInStopping',
                            },
                            {
                              TI_texttableentry: 'TI_I_42',
                              interval: '42',
                              texttableentry: 'GasFlowMeterHighFlowRate',
                            },
                            {
                              TI_texttableentry: 'TI_I_43',
                              interval: '43',
                              texttableentry:
                                'PreferentialOxidationAirFlowMeterFailureInGenerating',
                            },
                            {
                              TI_texttableentry: 'TI_I_44',
                              interval: '44',
                              texttableentry: 'PreferentialOxidationAirBlowerFailureInGenerating',
                            },
                            {
                              TI_texttableentry: 'TI_I_45',
                              interval: '45',
                              texttableentry: 'PreferentialOxidationAirBlowPath',
                            },
                            {
                              TI_texttableentry: 'TI_I_46',
                              interval: '46',
                              texttableentry: 'PreferentialOxidationAirNeedleValveFailure',
                            },
                            {
                              TI_texttableentry: 'TI_I_47',
                              interval: '47',
                              texttableentry: 'PreferentialOxidationAirFlowMeterFailureOnStartUp',
                            },
                            {
                              TI_texttableentry: 'TI_I_48',
                              interval: '48',
                              texttableentry: 'PreferentialOxidationAirBlowerFailureOnStartUp',
                            },
                            {
                              TI_texttableentry: 'TI_I_49',
                              interval: '49',
                              texttableentry: 'PreferentialOxidationAirFlowMeterFailureInStopping',
                            },
                            {
                              TI_texttableentry: 'TI_I_50',
                              interval: '50',
                              texttableentry: 'BoosterPumpOverLimit',
                            },
                            {
                              TI_texttableentry: 'TI_I_51',
                              interval: '51',
                              texttableentry: 'BoosterPumpUnderLimit',
                            },
                            {
                              TI_texttableentry: 'TI_I_52',
                              interval: '52',
                              texttableentry: 'IgniterDisconnection',
                            },
                            {
                              TI_texttableentry: 'TI_I_53',
                              interval: '53',
                              texttableentry: 'ExternalControlActive',
                            },
                            {
                              TI_texttableentry: 'TI_I_54',
                              interval: '54',
                              texttableentry: 'CheckVentilationFilter',
                            },
                            {
                              TI_texttableentry: 'TI_I_55',
                              interval: '55',
                              texttableentry: 'FuelCellDomestichotWaterMaximumTemperature',
                            },
                            {
                              TI_texttableentry: 'TI_I_56',
                              interval: '56',
                              texttableentry: 'ExternalHeatDemandActive',
                            },
                            {
                              TI_texttableentry: 'TI_I_57',
                              interval: '57',
                              texttableentry: 'ExternalLockActive',
                            },
                            {
                              TI_texttableentry: 'TI_I_58',
                              interval: '58',
                              texttableentry: 'IncorrectPasswordForWifi',
                            },
                            {
                              TI_texttableentry: 'TI_I_59',
                              interval: '59',
                              texttableentry: 'ParameterRestored',
                            },
                            {
                              TI_texttableentry: 'TI_I_60',
                              interval: '60',
                              texttableentry: 'KeyPadLookSet',
                            },
                            {
                              TI_texttableentry: 'TI_I_61',
                              interval: '61',
                              texttableentry: 'DisplayOrientationRotated',
                            },
                            {
                              TI_texttableentry: 'TI_I_62',
                              interval: '62',
                              texttableentry: 'WindowOpenDetection',
                            },
                            {
                              TI_texttableentry: 'TI_I_63',
                              interval: '63',
                              texttableentry: 'RefrigerationCircuitNotReadyForOperation',
                            },
                            {
                              TI_texttableentry: 'TI_I_64',
                              interval: '64',
                              texttableentry: 'FREE',
                            },
                            {
                              TI_texttableentry: 'TI_I_65',
                              interval: '65',
                              texttableentry: 'RecalibrationInProgress',
                            },
                            {
                              TI_texttableentry: 'TI_I_66',
                              interval: '66',
                              texttableentry: 'BatteryStateOfHealthBelowEightyPercent',
                            },
                            {
                              TI_texttableentry: 'TI_I_67',
                              interval: '67',
                              texttableentry: 'ZigbeeCommunicationDeactivated',
                            },
                            {
                              TI_texttableentry: 'TI_I_68',
                              interval: '68',
                              texttableentry: 'OperatingHoursCentralHeatingPump',
                            },
                            {
                              TI_texttableentry: 'TI_I_69',
                              interval: '69',
                              texttableentry: 'OperatingHoursMixerTwoCircuitPump',
                            },
                            {
                              TI_texttableentry: 'TI_I_70',
                              interval: '70',
                              texttableentry: 'InverterAcGridOverCurrent',
                            },
                            {
                              TI_texttableentry: 'TI_I_71',
                              interval: '71',
                              texttableentry: 'InverterAcGridOverVoltage',
                            },
                            {
                              TI_texttableentry: 'TI_I_72',
                              interval: '72',
                              texttableentry: 'InverterAcGridUnderVoltage',
                            },
                            {
                              TI_texttableentry: 'TI_I_73',
                              interval: '73',
                              texttableentry: 'InverterDcLinkOverVoltage',
                            },
                            {
                              TI_texttableentry: 'TI_I_74',
                              interval: '74',
                              texttableentry: 'InverterDcLinkUnderVoltage',
                            },
                            {
                              TI_texttableentry: 'TI_I_75',
                              interval: '75',
                              texttableentry: 'InverterBridgeOverTemperature',
                            },
                            {
                              TI_texttableentry: 'TI_I_76',
                              interval: '76',
                              texttableentry: 'InverterPowerFactorCorrectionOverTemperature',
                            },
                            {
                              TI_texttableentry: 'TI_I_77',
                              interval: '77',
                              texttableentry: 'InverterSoftwarePowerFactorCorrectionOverCurrent',
                            },
                            {
                              TI_texttableentry: 'TI_I_78',
                              interval: '78',
                              texttableentry: 'InverterInputCurrentSpeedDropProtection',
                            },
                            {
                              TI_texttableentry: 'TI_I_79',
                              interval: '79',
                              texttableentry: 'InverterCompressorCurrentSpeedDropProtection',
                            },
                            {
                              TI_texttableentry: 'TI_I_80',
                              interval: '80',
                              texttableentry: 'InverterFieldWeakeningSpeedDropProtection',
                            },
                            {
                              TI_texttableentry: 'TI_I_81',
                              interval: '81',
                              texttableentry: 'InverterBridgeTemperatureDerating',
                            },
                            {
                              TI_texttableentry: 'TI_I_82',
                              interval: '82',
                              texttableentry: 'InverterPowerFactorCorrectionTemperatureDerating',
                            },
                            {
                              TI_texttableentry: 'TI_I_83',
                              interval: '83',
                              texttableentry: 'FourThreeWayValveMinimumMassflowControl',
                            },
                            {
                              TI_texttableentry: 'TI_I_84',
                              interval: '84',
                              texttableentry: 'FourThreeWayValveMinimumReturnTemperatureControl',
                            },
                            {
                              TI_texttableentry: 'TI_I_85',
                              interval: '85',
                              texttableentry: 'ControlledLowPressureShutOffRefrigerantCircuit',
                            },
                            {
                              TI_texttableentry: 'TI_I_86',
                              interval: '86',
                              texttableentry: 'ControlledHighPressureShutOffRefrigerantCircuit',
                            },
                            {
                              TI_texttableentry: 'TI_I_87',
                              interval: '87',
                              texttableentry: 'DomesticHotWaterLoadingWaitingTimeActive',
                            },
                            {
                              TI_texttableentry: 'TI_I_88',
                              interval: '88',
                              texttableentry: 'FillingCompleted',
                            },
                            {
                              TI_texttableentry: 'TI_I_89',
                              interval: '89',
                              texttableentry: 'SetSystemTimeForward',
                            },
                            {
                              TI_texttableentry: 'TI_I_90',
                              interval: '90',
                              texttableentry: 'SetTimeBackward',
                            },
                            {
                              TI_texttableentry: 'TI_I_91',
                              interval: '91',
                              texttableentry: 'RestoreEepromToDefault',
                            },
                            {
                              TI_texttableentry: 'TI_I_92',
                              interval: '92',
                              texttableentry: 'ResetEnergyBalanceData',
                            },
                            {
                              TI_texttableentry: 'TI_I_93',
                              interval: '93',
                              texttableentry: 'BurnerBlockedDueToHeatingPumpMalfunction',
                            },
                            {
                              TI_texttableentry: 'TI_I_94',
                              interval: '94',
                              texttableentry: 'DeviceServiceUpcoming',
                            },
                            {
                              TI_texttableentry: 'TI_I_95',
                              interval: '95',
                              texttableentry: 'VentilationFilterExchangeUpcoming',
                            },
                            {
                              TI_texttableentry: 'TI_I_96',
                              interval: '96',
                              texttableentry: 'UnknownLagDeviceRecognized',
                            },
                            {
                              TI_texttableentry: 'TI_I_97',
                              interval: '97',
                              texttableentry: 'DeletedNodeIdSerialListOnLead',
                            },
                            {
                              TI_texttableentry: 'TI_I_98',
                              interval: '98',
                              texttableentry: 'SystemLagDeviceAdded',
                            },
                            {
                              TI_texttableentry: 'TI_I_99',
                              interval: '99',
                              texttableentry: 'LegionellaProtectionTemperatureReached',
                            },
                            {
                              TI_texttableentry: 'TI_I_100',
                              interval: '100',
                              texttableentry: 'CompressorMaxCondensionPressureReached',
                            },
                            {
                              TI_texttableentry: 'TI_I_101',
                              interval: '101',
                              texttableentry: 'CompressorMinEvaporatingPressureHeatingReached',
                            },
                            {
                              TI_texttableentry: 'TI_I_102',
                              interval: '102',
                              texttableentry: 'CompressorMinEvaporatingPressureCoolingReached',
                            },
                            {
                              TI_texttableentry: 'TI_I_103',
                              interval: '103',
                              texttableentry: 'CompressorMaxEvaporatingPressureReached',
                            },
                            {
                              TI_texttableentry: 'TI_I_104',
                              interval: '104',
                              texttableentry: 'CompressorMaxDischargeTemperatueReached',
                            },
                            {
                              TI_texttableentry: 'TI_I_105',
                              interval: '105',
                              texttableentry:
                                'CompressorMaxRuntimeAtLowEvaporatingTemperatureReached',
                            },
                            {
                              TI_texttableentry: 'TI_I_106',
                              interval: '106',
                              texttableentry: 'CompressorMaxPressureDifferenceReached',
                            },
                            {
                              TI_texttableentry: 'TI_I_107',
                              interval: '107',
                              texttableentry: 'CompressorMaxCondensingTemperature',
                            },
                            {
                              TI_texttableentry: 'TI_I_108',
                              interval: '108',
                              texttableentry: 'CompressorMaxTorqueReached',
                            },
                            {
                              TI_texttableentry: 'TI_I_109',
                              interval: '109',
                              texttableentry: 'CompressorMaxEvaporatorTemperatureReached',
                            },
                            {
                              TI_texttableentry: 'TI_I_110',
                              interval: '110',
                              texttableentry: 'CompressorMInPressureRatioReached',
                            },
                            {
                              TI_texttableentry: 'TI_I_111',
                              interval: '111',
                              texttableentry: 'CompressorMInEvaporatingTemperatureReached',
                            },
                            {
                              TI_texttableentry: 'TI_I_112',
                              interval: '112',
                              texttableentry: 'MinimumSecondaryOutletTemperatureReached',
                            },
                            {
                              TI_texttableentry: 'TI_I_113',
                              interval: '113',
                              texttableentry: 'SmartGridLock',
                            },
                            {
                              TI_texttableentry: 'TI_I_114',
                              interval: '114',
                              texttableentry: 'NormalOperation',
                            },
                            {
                              TI_texttableentry: 'TI_I_115',
                              interval: '115',
                              texttableentry: 'SmartGridRecommendedOperation',
                            },
                            {
                              TI_texttableentry: 'TI_I_116',
                              interval: '116',
                              texttableentry: 'SmartGridForcedOperation',
                            },
                            {
                              TI_texttableentry: 'TI_I_117',
                              interval: '117',
                              texttableentry: 'HomeEnergyManagementSystemActive',
                            },
                            {
                              TI_texttableentry: 'TI_I_118',
                              interval: '118',
                              texttableentry: 'FloorHeatingCircuitOneTemperatureLimiterActivated',
                            },
                            {
                              TI_texttableentry: 'TI_I_119',
                              interval: '119',
                              texttableentry: 'FloorHeatingCircuitTwoTemperatureLimiterActivated',
                            },
                            {
                              TI_texttableentry: 'TI_I_120',
                              interval: '120',
                              texttableentry: 'NoiseReductionModeActive',
                            },
                            {
                              TI_texttableentry: 'TI_I_121',
                              interval: '121',
                              texttableentry: 'MixerOneCircuitHumidityProtectionActivated',
                            },
                            {
                              TI_texttableentry: 'TI_I_122',
                              interval: '122',
                              texttableentry: 'MixerTwoCircuitHumidityProtectionActivated',
                            },
                            {
                              TI_texttableentry: 'TI_I_123',
                              interval: '123',
                              texttableentry: 'MaximumReturnTemperatureRefrigerantCircuitReached',
                            },
                            {
                              TI_texttableentry: 'TI_I_124',
                              interval: '124',
                              texttableentry: 'MinimumReturnTemperatureRefrigerantCircuitReached',
                            },
                            {
                              TI_texttableentry: 'TI_I_125',
                              interval: '125',
                              texttableentry: 'MaximumPrimaryInletTemperatureReached',
                            },
                            {
                              TI_texttableentry: 'TI_I_126',
                              interval: '126',
                              texttableentry: 'MinimumPrimaryInletTemperatureReached',
                            },
                            {
                              TI_texttableentry: 'TI_I_127',
                              interval: '127',
                              texttableentry: 'MaximumCompressorPressureDifferenceAtStartReached',
                            },
                            {
                              TI_texttableentry: 'TI_I_128',
                              interval: '128',
                              texttableentry: 'MinimumOilSumpTemperatureReached',
                            },
                            {
                              TI_texttableentry: 'TI_I_129',
                              interval: '129',
                              texttableentry: 'PressureImbalanceRefrigerantCircuitFourWayValve',
                            },
                            {
                              TI_texttableentry: 'TI_I_130',
                              interval: '130',
                              texttableentry: 'RefrigerantCircuitMaximumStartupDurationExceeded',
                            },
                            {
                              TI_texttableentry: 'TI_I_131',
                              interval: '131',
                              texttableentry: 'MinimumEvaporatingTemperatureReached',
                            },
                            {
                              TI_texttableentry: 'TI_I_132',
                              interval: '132',
                              texttableentry: 'ResetOutdoorControllerMainUnit',
                            },
                            {
                              TI_texttableentry: 'TI_I_133',
                              interval: '133',
                              texttableentry: 'ResetCommunicationControlUnit',
                            },
                            {
                              TI_texttableentry: 'TI_I_134',
                              interval: '134',
                              texttableentry: 'ForcedDefrostingActivated',
                            },
                            {
                              TI_texttableentry: 'TI_I_135',
                              interval: '135',
                              texttableentry: 'ControlledDefrostingActivated',
                            },
                            {
                              TI_texttableentry: 'TI_I_136',
                              interval: '136',
                              texttableentry: 'InverterDcOverCurrent',
                            },
                            {
                              TI_texttableentry: 'TI_I_137',
                              interval: '137',
                              texttableentry: 'LagDeviceDtcReported',
                            },
                            {
                              TI_texttableentry: 'TI_I_138',
                              interval: '138',
                              texttableentry: 'BackUpPowerFunctionInstalled',
                            },
                            {
                              TI_texttableentry: 'TI_I_139',
                              interval: '139',
                              texttableentry: 'OnePhaseGridDetected',
                            },
                            {
                              TI_texttableentry: 'TI_I_140',
                              interval: '140',
                              texttableentry: 'ThreePhaseGridDetected',
                            },
                            {
                              TI_texttableentry: 'TI_I_141',
                              interval: '141',
                              texttableentry: 'InverterGatewayActive',
                            },
                            {
                              TI_texttableentry: 'TI_I_142',
                              interval: '142',
                              texttableentry: 'MinimumCompressorOnTimeViolated',
                            },
                            {
                              TI_texttableentry: 'TI_I_143',
                              interval: '143',
                              texttableentry: 'PowerSupplierLock',
                            },
                            {
                              TI_texttableentry: 'TI_I_144',
                              interval: '144',
                              texttableentry: 'InverterAcInputZeroCrossing',
                            },
                            {
                              TI_texttableentry: 'TI_I_145',
                              interval: '145',
                              texttableentry: 'OutdoorUnitOverPowerProtection',
                            },
                            {
                              TI_texttableentry: 'TI_I_146',
                              interval: '146',
                              texttableentry: 'OverheatingOutdoorHeatExchangerCooling',
                            },
                            {
                              TI_texttableentry: 'TI_I_147',
                              interval: '147',
                              texttableentry: 'OverheatingIndoorHeatExchangerHeating',
                            },
                            {
                              TI_texttableentry: 'TI_I_148',
                              interval: '148',
                              texttableentry: 'OverheatingOutdoorHeatExchangerHeating',
                            },
                            {
                              TI_texttableentry: 'TI_I_149',
                              interval: '149',
                              texttableentry: 'IndoorNonDefrostRequestDuringDeicerProcess',
                            },
                            {
                              TI_texttableentry: 'TI_I_150',
                              interval: '150',
                              texttableentry: 'IndoorDefrostRequestDuringNonDeicerProcess',
                            },
                            {
                              TI_texttableentry: 'TI_I_151',
                              interval: '151',
                              texttableentry: 'SecondaryOutletTemperatureCountermeasure',
                            },
                            {
                              TI_texttableentry: 'TI_I_152',
                              interval: '152',
                              texttableentry: 'LowPressureCountermeasure',
                            },
                            {
                              TI_texttableentry: 'TI_I_153',
                              interval: '153',
                              texttableentry: 'ElectricalFailureElectronicExpansionValveOneMotor',
                            },
                            {
                              TI_texttableentry: 'TI_I_154',
                              interval: '154',
                              texttableentry: 'ElectricalFailureElectronicExpansionValveTwoMotor',
                            },
                            {
                              TI_texttableentry: 'TI_I_155',
                              interval: '155',
                              texttableentry: 'FloorDryingAbortedByUser',
                            },
                            {
                              TI_texttableentry: 'TI_I_156',
                              interval: '156',
                              texttableentry: 'DefrostAlertDueToLowWaterFlow',
                            },
                            {
                              TI_texttableentry: 'TI_I_157',
                              interval: '157',
                              texttableentry: 'DesiredCompressorOutletTemperatureHeatingExceeded',
                            },
                            {
                              TI_texttableentry: 'TI_I_158',
                              interval: '158',
                              texttableentry: 'DesiredCompressorOutletTemperatureCoolingExceeded',
                            },
                            {
                              TI_texttableentry: 'TI_I_159',
                              interval: '159',
                              texttableentry: 'HeatSinkOverTemperature',
                            },
                            {
                              TI_texttableentry: 'TI_I_160',
                              interval: '160',
                              texttableentry: 'RoomFrostProtectionDomesticHotWaterHeatPump',
                            },
                            {
                              TI_texttableentry: 'TI_I_161',
                              interval: '161',
                              texttableentry: 'OffPeakElectricitySignalActive',
                            },
                            {
                              TI_texttableentry: 'TI_I_65533',
                              interval: '65533',
                              texttableentry: 'AcknowledgeInformationMessage',
                            },
                            {
                              TI_texttableentry: 'TI_I_65534',
                              interval: '65534',
                              texttableentry: 'InfoHasBeenConfirmed',
                            },
                          ],
                          path: 'PA_Struc/PA_DTC/STR_12ByteStrucDTCInfo/PA_DTC',
                          unit: '',
                          translationid: 'TI_DtcInfo',
                          bitposition: '0',
                          name: 'PA_DTC',
                          value: 'NoInfo',
                        },
                        {
                          semantic: 'DATETIME',
                          longname: 'DtcTime',
                          byteposition: '2',
                          dopname: '8 Byte Structure DateTime',
                          precision: '',
                          byteLength: '-1',
                          type: 'eSTRUCTURE',
                          shortname: 'PA_DtcTime',
                          constraints: '',
                          structure: [
                            {
                              semantic: 'DATE',
                              longname: 'Date',
                              byteposition: '0',
                              dopname: '4 Byte Structure Date',
                              precision: '',
                              byteLength: '-1',
                              type: 'eSTRUCTURE',
                              shortname: 'PA_Date',
                              constraints: '',
                              structure: [
                                {
                                  semantic: 'CENTURY',
                                  longname: 'Century',
                                  byteposition: '0',
                                  dopname: '1 Byte Identical uint8 Century',
                                  precision: '',
                                  byteLength: '8',
                                  type: 'eA_UINT32',
                                  shortname: 'PA_Centu',
                                  constraints: '[0:255]',
                                  path:
                                    'PA_Struc/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Date/PA_Centu',
                                  unit: '',
                                  translationid: 'TI_Century',
                                  bitposition: '0',
                                  name: 'PA_Centu',
                                  value: '0',
                                },
                                {
                                  semantic: 'YEAR',
                                  longname: 'Year',
                                  byteposition: '1',
                                  dopname: '1 Byte Identical uint8 Year',
                                  precision: '',
                                  byteLength: '8',
                                  type: 'eA_UINT32',
                                  shortname: 'PA_Year',
                                  constraints: '[0:255]',
                                  path:
                                    'PA_Struc/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Date/PA_Year',
                                  unit: 'yr',
                                  translationid: 'TI_Year',
                                  bitposition: '0',
                                  name: 'PA_Year',
                                  value: '0',
                                },
                                {
                                  semantic: 'MONTH',
                                  longname: 'Month',
                                  byteposition: '2',
                                  dopname: '1 Byte Identical uint8 Month',
                                  precision: '',
                                  byteLength: '8',
                                  type: 'eA_UINT32',
                                  shortname: 'PA_Month',
                                  constraints: '[0:255]',
                                  path:
                                    'PA_Struc/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Date/PA_Month',
                                  unit: 'm',
                                  translationid: 'TI_Month',
                                  bitposition: '0',
                                  name: 'PA_Month',
                                  value: '0',
                                },
                                {
                                  semantic: 'DAY',
                                  longname: 'Day',
                                  byteposition: '3',
                                  dopname: '1 Byte Identical uint8 Day',
                                  precision: '',
                                  byteLength: '8',
                                  type: 'eA_UINT32',
                                  shortname: 'PA_Day',
                                  constraints: '[0:255]',
                                  path:
                                    'PA_Struc/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Date/PA_Day',
                                  unit: 'd',
                                  translationid: 'TI_Day',
                                  bitposition: '0',
                                  name: 'PA_Day',
                                  value: '0',
                                },
                              ],
                              path: 'PA_Struc/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Date',
                              unit: '',
                              translationid: 'TI_Date',
                              bitposition: '0',
                              name: 'PA_Date',
                              value: '4',
                            },
                            {
                              semantic: 'TIME',
                              longname: 'Time',
                              byteposition: '4',
                              dopname: '4 Byte Structure Time',
                              precision: '',
                              byteLength: '-1',
                              type: 'eSTRUCTURE',
                              shortname: 'PA_Time',
                              constraints: '',
                              structure: [
                                {
                                  semantic: 'WEEKDAY',
                                  longname: 'Weekday',
                                  byteposition: '0',
                                  dopname: '1 Byte TextTable WeekDay',
                                  precision: '',
                                  byteLength: '8',
                                  type: 'eTEXTTABLE',
                                  shortname: 'PA_Weekd',
                                  constraints: '',
                                  structure: [
                                    {
                                      TI_texttableentry: 'TI_Monday',
                                      interval: '0',
                                      texttableentry: 'Monday',
                                    },
                                    {
                                      TI_texttableentry: 'TI_Tuesday',
                                      interval: '1',
                                      texttableentry: 'Tuesday',
                                    },
                                    {
                                      TI_texttableentry: 'TI_Wednesday',
                                      interval: '2',
                                      texttableentry: 'Wednesday',
                                    },
                                    {
                                      TI_texttableentry: 'TI_Thursday',
                                      interval: '3',
                                      texttableentry: 'Thursday',
                                    },
                                    {
                                      TI_texttableentry: 'TI_Friday',
                                      interval: '4',
                                      texttableentry: 'Friday',
                                    },
                                    {
                                      TI_texttableentry: 'TI_Saturday',
                                      interval: '5',
                                      texttableentry: 'Saturday',
                                    },
                                    {
                                      TI_texttableentry: 'TI_Sunday',
                                      interval: '6',
                                      texttableentry: 'Sunday',
                                    },
                                  ],
                                  path:
                                    'PA_Struc/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Time/PA_Weekd',
                                  unit: '',
                                  translationid: 'TI_Weekday',
                                  bitposition: '0',
                                  name: 'PA_Weekd',
                                  value: 'Monday',
                                },
                                {
                                  semantic: 'HOUR',
                                  longname: 'Hour',
                                  byteposition: '1',
                                  dopname: '1 Byte Identical uint8 Hour',
                                  precision: '',
                                  byteLength: '8',
                                  type: 'eA_UINT32',
                                  shortname: 'PA_Hour',
                                  constraints: '[0:255]',
                                  path:
                                    'PA_Struc/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Time/PA_Hour',
                                  unit: 'h',
                                  translationid: 'TI_Hour',
                                  bitposition: '0',
                                  name: 'PA_Hour',
                                  value: '0',
                                },
                                {
                                  semantic: 'MINUTE',
                                  longname: 'Minute',
                                  byteposition: '2',
                                  dopname: '1 Byte Identical uint8 Minute',
                                  precision: '',
                                  byteLength: '8',
                                  type: 'eA_UINT32',
                                  shortname: 'PA_Minut',
                                  constraints: '[0:255]',
                                  path:
                                    'PA_Struc/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Time/PA_Minut',
                                  unit: 'min',
                                  translationid: 'TI_Minute',
                                  bitposition: '0',
                                  name: 'PA_Minut',
                                  value: '0',
                                },
                                {
                                  semantic: 'SECOND',
                                  longname: 'Second',
                                  byteposition: '3',
                                  dopname: '1 Byte Identical uint8 Second',
                                  precision: '',
                                  byteLength: '8',
                                  type: 'eA_UINT32',
                                  shortname: 'PA_Secon',
                                  constraints: '[0:255]',
                                  path:
                                    'PA_Struc/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Time/PA_Secon',
                                  unit: 's',
                                  translationid: 'TI_Second',
                                  bitposition: '0',
                                  name: 'PA_Secon',
                                  value: '0',
                                },
                              ],
                              path: 'PA_Struc/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime/PA_Time',
                              unit: '',
                              translationid: 'TI_Time',
                              bitposition: '0',
                              name: 'PA_Time',
                              value: '4',
                            },
                          ],
                          path: 'PA_Struc/PA_DTC/STR_12ByteStrucDTCInfo/PA_DtcTime',
                          unit: '',
                          translationid: 'TI_Time',
                          bitposition: '0',
                          name: 'PA_DtcTime',
                          value: '2',
                        },
                        {
                          semantic: 'VALUE',
                          longname: 'BusAddress',
                          byteposition: '10',
                          dopname: '1 Byte Identical uint8 Hex',
                          precision: '',
                          byteLength: '8',
                          type: 'eA_UINT32',
                          shortname: 'PA_BusAddre',
                          constraints: '[0:255]',
                          path: 'PA_Struc/PA_DTC/STR_12ByteStrucDTCInfo/PA_BusAddre',
                          unit: '',
                          translationid: 'TI_BusAddress',
                          bitposition: '0',
                          name: 'PA_BusAddre',
                          value: '0',
                        },
                        {
                          semantic: 'ENUM',
                          longname: 'BusType',
                          byteposition: '11',
                          dopname: '1 Byte TextTable BusType',
                          precision: '',
                          byteLength: '8',
                          type: 'eTEXTTABLE',
                          shortname: 'PA_BusType',
                          constraints: '',
                          structure: [
                            {
                              TI_texttableentry: 'TI_OwnBus',
                              interval: '0',
                              texttableentry: 'OwnBus',
                            },
                            {
                              TI_texttableentry: 'TI_PlusBus',
                              interval: '1',
                              texttableentry: 'PlusBus',
                            },
                            {
                              TI_texttableentry: 'TI_CanInternal',
                              interval: '2',
                              texttableentry: 'CanInternal',
                            },
                            {
                              TI_texttableentry: 'TI_CanExternal',
                              interval: '3',
                              texttableentry: 'CanExternal',
                            },
                            {
                              TI_texttableentry: 'TI_InternalUart',
                              interval: '4',
                              texttableentry: 'InternalUart',
                            },
                            {
                              TI_texttableentry: 'TI_Zigbee',
                              interval: '5',
                              texttableentry: 'Zigbee',
                            },
                            {
                              TI_texttableentry: 'TI_CanRaw',
                              interval: '6',
                              texttableentry: 'CanRaw',
                            },
                            {
                              TI_texttableentry: 'TI_Unkown',
                              interval: '7',
                              texttableentry: 'Unkown',
                            },
                            {
                              TI_texttableentry: 'TI_ModBus',
                              interval: '8',
                              texttableentry: 'ModBus',
                            },
                            {
                              TI_texttableentry: 'TI_EEBUS',
                              interval: '9',
                              texttableentry: 'EEBUS',
                            },
                            {
                              TI_texttableentry: 'TI_PlusBusTwo',
                              interval: '10',
                              texttableentry: 'PlusBusTwo',
                            },
                            {
                              TI_texttableentry: 'TI_ISquaredCBus',
                              interval: '11',
                              texttableentry: 'ISquaredCBus',
                            },
                            {
                              TI_texttableentry: 'TI_HemsBus',
                              interval: '12',
                              texttableentry: 'HemsBus',
                            },
                            {
                              TI_texttableentry: 'TI_SolarLogBus',
                              interval: '13',
                              texttableentry: 'SolarLogBus',
                            },
                            {
                              TI_texttableentry: 'TI_ServiceBus',
                              interval: '14',
                              texttableentry: 'ServiceBus',
                            },
                          ],
                          path: 'PA_Struc/PA_DTC/STR_12ByteStrucDTCInfo/PA_BusType',
                          unit: '',
                          translationid: 'TI_BusType',
                          bitposition: '0',
                          name: 'PA_BusType',
                          value: 'OwnBus',
                        },
                      ],
                      path: 'PA_Struc/PA_DTC/STR_12ByteStrucDTCInfo',
                      unit: '',
                      translationid: '',
                      bitposition: '0',
                      name: 'STR_12ByteStrucDTCInfo',
                      value: '4',
                    },
                  ],
                  path: 'PA_Struc/PA_DTC',
                  unit: '',
                  translationid: 'TI_DTC',
                  bitposition: '0',
                  name: 'PA_DTC',
                  value: '1',
                },
              ],
              path: 'PA_Struc',
              unit: '',
              translationid: '',
              bitposition: '0',
              name: 'PA_Struc',
              value: '',
            },
          ],
        },
      ],
    };
  }
}
